import React from "react";
import styled from "styled-components";
import { Container } from "../../styles/Common";
import { ReactComponent as IcoHome } from "../../styles/images/ico_home.svg";
import { ReactComponent as IcoMyPage } from "../../styles/images/ico_myPage.svg";
import { ReactComponent as Logo } from "../../styles/images/ico_logo_small.svg";
import { useNavigate } from "react-router-dom";

const Footer = (props) => {
  const { isOpen, setOpen } = props;
  const navigate = useNavigate();
  return (
    <FooterWrap>
      <Container>
        <footer>
          <button
            onClick={() => {
              setOpen(false);
              navigate("/home");
            }}
          >
            <IcoHome />
          </button>
          <LogoBtn
            className="logoBtn"
            onClick={() => {
              navigate("/point/change");
            }}
          >
            <Logo />
          </LogoBtn>
          <button>
            <IcoMyPage
              onClick={() => {
                navigate("/mypage/edit");
              }}
            />
          </button>
        </footer>
      </Container>
    </FooterWrap>
  );
};

export default Footer;

const FooterWrap = styled.div`
  width: 100%;
  position: fixed;
  z-index: 10;
  bottom: 0;
  footer {
    height: 8.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4.5rem;
    background-color: ${({ theme }) => theme.color.purple_dark};
  }
  button {
    background-color: transparent;
    :active,
    :focus {
      outline: none !important;
      box-shadow: none !important;
      background-color: transparent;
    }
    -webkit-tap-highlight-color: transparent !important;
  }
  .logoBtn {
    background-color: ${({ theme }) => theme.color.white};
  }
`;

const LogoBtn = styled.button`
  width: 12rem;
  height: 5rem;
  border-radius: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
